import React from 'react';
import { BookOpen, ArrowRight } from 'lucide-react';
import { useDbNavigate } from '../../context/DatabaseContext';
import { SUPPORTING_DOCS_GROUPS } from './supportingDocsConfig';

const SupportingDocsDashboardPage = () => {
  const navigate = useDbNavigate();

  return (
    <div className="stui-dashboard-body">
      <div className="stui-dashboard-header">
        <BookOpen size={20} className="stui-dashboard-header-icon" />
        <h1 className="stui-dashboard-header-title">Supporting Documentation</h1>
        <span className="stui-dashboard-header-subtitle">{SUPPORTING_DOCS_GROUPS.length} groups</span>
      </div>

      <div className="stui-dashboard-group-header">
        <BookOpen size={16} className="stui-dashboard-header-icon" />
        <span className="stui-dashboard-group-title">Reference Data</span>
        <span className="stui-dashboard-group-count">{SUPPORTING_DOCS_GROUPS.length} groups available</span>
      </div>

      <div className="stui-dashboard-tile-grid">
        {SUPPORTING_DOCS_GROUPS.map(group => (
          <div
            key={group.id}
            className="stui-tile stui-clickable"
            onClick={() => navigate(`/${group.route}`)}
          >
            <div className="stui-tile-header">
              <span className="stui-tile-title">{group.label}</span>
              <ArrowRight size={16} className="stui-dashboard-tile-action" />
            </div>
            <div className="stui-dashboard-tile-content">
              <p className="stui-dashboard-tile-description">{group.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportingDocsDashboardPage;
